module.exports = __webpack_public_path__ + "src/assets/textures/env/street_road/road_01_2k_bake.png";